module.exports = __webpack_public_path__ + "static/img/orderremark1.5c84db9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdd/orderremark1.png
// module id = 1252
// module chunks = 0